// extracted by mini-css-extract-plugin
var _1 = "navigation-item__PMduF";
var _2 = "navigation-item--active__Fu8ZV";
var _3 = "opacity-hover__mx3E8";
export { _1 as "navigationItem", _2 as "navigationItemActive", _3 as "opacityHover" }
